import { z } from 'zod';

/**
 * The annual-report framework a financial statement is presented under.
 *
 * The narrow half of `AccountingRegulation`: statement rows, notes and the
 * annual report differ between K2 and K3 only, so anything keyed on that
 * distinction takes this rather than the five-variant regulation.
 */
type AccountingFramework = 'K2' | 'K3';

const otherAccountingFramework = (framework: AccountingFramework): AccountingFramework =>
  framework === 'K2' ? 'K3' : 'K2';

const accountingRegulationSchema = z.enum([
  'K2',
  'K3',
  'SmallWithK3',
  'SmallCorporateGroup',
  'CorporateGroup',
]);
type AccountingRegulation = z.infer<typeof accountingRegulationSchema>;

/** Assumed where a client's own regulation is not known yet. */
const DEFAULT_REGULATION: AccountingRegulation = 'K2';

/** The framework a regulation presents its annual report under — every variant but `K2` is a K3 one. */
function frameworkFromRegulation(regulation: AccountingRegulation): AccountingFramework {
  return regulation === 'K2' ? 'K2' : 'K3';
}

export {
  accountingRegulationSchema,
  DEFAULT_REGULATION,
  frameworkFromRegulation,
  otherAccountingFramework,
  type AccountingFramework,
  type AccountingRegulation,
};
